import { render } from "./HelloWorld.vue?vue&type=template&id=01474bca"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=01474bca&lang=scss"
script.render = render

export default script